<template>
  <div>
    <header class="bar bar-nav">
      <h1 class="title">商品详细</h1>
      <router-link :to="{name : 'orderContentConfirm'}" class="button button-link button-nav pull-left">
        <span class="icon icon-left" style="font-size: 18px">返回</span>
      </router-link>
    </header>
    <div class="content">
      <div class="list-block" style="margin-top: 2px;">
        <div class="list-block media-list" v-for="order in orderList">
          <ul>
            <li>
              <router-link :to="{ name: 'goods'}" class="item-link item-content">

                <div class="item-media"><img src="/emktResources/resocurces/img/gene.jpg" style='width: 4rem;'></div>
                <div class="item-inner">
                  <div class="item-title-row">
                    <div>{{ order.merchandiseLabel}}</div>
                  </div>
                  <div class="item-title" style="color: #d94b73" v-if="sessionInfo.customerInfo && sessionInfo.customerInfo.ssoFlag === 1 ">¥{{order.priceMax}}</div>
                  <div class="item-title" style="color: #d94b73" v-else>¥{{order.priceMin}}</div>
                  <div class="item-title">合计{{order.productQuantity}}个产品</div>
                </div>

              </router-link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import {mapState} from 'vuex'
  export default {
    data () {
      return {
        orderList: []
      }
    },
    mounted () {
    },
    created () {
      this.orderList = this.fetchData()
    },
    methods: {
      fetchData () {
        return this.$route.query.orderList
      }
    },
    computed: {
      ...mapState([
        'sessionInfo'
      ])
    }
  }
</script>



// WEBPACK FOOTER //
// OrderConfirmDetail.vue?78863779